import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=339a2582&scoped=true&"
import script from "./ColorField.vue?vue&type=script&lang=js&"
export * from "./ColorField.vue?vue&type=script&lang=js&"
import style0 from "./ColorField.vue?vue&type=style&index=0&id=339a2582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339a2582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VColorPicker,VMenu,VTextField})
